import angular from 'angular';
import WorkCalendar from 'common/models/work-calendar';

module.exports = angular.module('common.services.weekday-work-calendar', [])
.factory('weekdayWorkCalendar', function() {
  var opts = {
    workdays: 'mon..fri',
    holidays: [
      '1/1',
      '7/4',
      '12/25'
    ]
  };
  return new WorkCalendar(opts);
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/weekday-work-calendar.js
 **/